document.addEventListener("DOMContentLoaded", async function () {
    const section = document.querySelector(".looxReviewsV1");

    if (!section) return;

    const settings = JSON.parse(section.querySelector(".looxReviewsV1Settings").textContent);

    if (!settings.store_id) return;

    const endpoint = `https://storefront-api.loox.io/storefront/v1/store/${settings.store_id}/product-reviews`;

    const list = section.querySelector(".looxReviewsV1List");
    const listTitle = section.querySelector(".looxReviewsV1FiltersTitle");
    const empty = section.querySelector(".looxReviewsV1Empty");
    const moreButton = section.querySelector(".looxReviewsV1MoreButton");
    const sortSelect = section.querySelector(".looxReviewsV1FiltersSortSelect");
    const sortValue = section.querySelector(".looxReviewsV1FiltersSortValue");
    const photosButton = section.querySelector(".looxReviewsV1FiltersContentPhoto");
    const clearButton = section.querySelector(".looxReviewsV1FiltersContentClear");
    const tiles = section.querySelectorAll(".looxReviewsV1Tile");
    const rows = section.querySelectorAll(".looxReviewsV1CountsRow");
    const allCount = section.querySelector(".looxReviewsV1TileAllInfoCount");

    // product filter cards carry each block's title override, keyed by product id
    const productTitles = Object.fromEntries([...tiles].map(tile => [tile.dataset.productId, tile.dataset.productTitle]));

    // active filters
    const state = {productId: "", productTitle: "", rating: 0, photos: false, sort: "featured:desc"};

    // paging for the current filters, reset on every fresh load
    let page = 1;
    let pending = [];
    let hasMore = true;

    // mobile-only swiper
    new Swiper(section.querySelector(".looxReviewsV1Rail"), {
        slidesPerView: "auto",
        spaceBetween: 8,
        // matched to 20px left padding on section
        slidesOffsetAfter: 20,
        breakpoints: {
            801: {enabled: false, spaceBetween: 0}
        },
        // classes for hiding/showing white gradient on right side of swiper
        on: {
            reachEnd() {
                this.el.classList.add("end");
            },
            fromEdge() {
                this.el.classList.remove("end");
            }
        }
    });

    const formatNumber = number => number.toLocaleString("en-NZ");

    const formatDate = date => new Date(date).toLocaleDateString("en-NZ", {
        day: "numeric",
        month: "short",
        year: "numeric"
    });

    const initials = name => name.split(/[\s&]+/).filter(Boolean).slice(0, 2).map(word => word[0]).join("").toUpperCase();

    async function request(path, params = {}) {
        const response = await fetch(`${endpoint}${path}?${new URLSearchParams(params)}`);

        if (!response.ok) throw new Error(`Loox responded with ${response.status}`);

        return response.json();
    }

    function starsHTML(rating, starClass) {
        return [1, 2, 3, 4, 5]
            .map(star => `<div class="${starClass}${star <= Math.round(rating) ? "" : " empty"}"></div>`)
            .join("");
    }

    function reviewCard(review) {
        const card = document.createElement("div");
        card.className = "looxReviewsV1Card";
        card.innerHTML = `
            <div class="looxReviewsV1CardHead">
                <div class="looxReviewsV1CardHeadStars">${starsHTML(review.rating, "looxReviewsV1CardHeadStarsItem")}</div>
                <div class="looxReviewsV1CardHeadDate">${formatDate(review.date)}</div>
            </div>
            <div class="looxReviewsV1CardBody"></div>
            ${review.media[0] ? `<img class="looxReviewsV1CardImage" src="${review.media[0].thumbnailUrl || review.media[0].url}" alt="">` : ""}
            <div class="looxReviewsV1CardFoot">
                <div class="looxReviewsV1CardFootInitials">${initials(review.reviewer.name)}</div>
                <div class="looxReviewsV1CardFootInfo">
                    <div class="looxReviewsV1CardFootInfoName"></div>
                    ${review.verified ? `<div class="looxReviewsV1CardFootInfoVerified">✓ ${settings.verified_label}</div>` : ""}
                </div>
                <div class="looxReviewsV1CardFootProduct"></div>
            </div>
        `;

        card.querySelector(".looxReviewsV1CardBody").textContent = review.body;
        card.querySelector(".looxReviewsV1CardFootInfoName").textContent = review.reviewer.name;
        card.querySelector(".looxReviewsV1CardFootProduct").textContent = productTitles[review.product.id] || review.product.name;

        return card;
    }

    async function loadCounts() {
        // bottomline returns the average, total and per-star counts in one call
        const path = state.productId ? `/bottomline/${state.productId}` : "/bottomline";
        const data = await request(path).catch(error => console.error("Loox reviews failed:", error));

        if (!data) return;

        const {totalReviews: total, averageRating: average, ratingDistribution: counts} = data;

        section.querySelector(".looxReviewsV1CountsScoreAverage").textContent = average.toFixed(1);
        section.querySelector(".looxReviewsV1CountsScoreStars").innerHTML = starsHTML(average, "looxReviewsV1CountsScoreStarsItem");
        section.querySelector(".looxReviewsV1CountsScoreTotal").textContent = `${formatNumber(total)} ${settings.total_label}`;

        // the all reviews card shows store-wide numbers
        if (!state.productId) allCount.textContent = `${average.toFixed(1)} · ${formatNumber(total)}`;

        for (const row of rows) {
            const count = counts[row.dataset.rating];
            row.querySelector(".looxReviewsV1CountsRowBar").style.width = total ? `${(count / total) * 100}%` : 0;
            row.querySelector(".looxReviewsV1CountsRowCount").textContent = formatNumber(count);
        }
    }

    // fresh starts the list over for new filters, otherwise it appends the next batch
    async function loadReviews(fresh) {
        // sort by featured or date based on whether "With Photos" toggle is selected
        const params = {sort: state.photos ? "featured" : "date", limit: state.photos ? 250 : settings.limit};

        if (state.sort) [params.sort, params.direction] = state.sort.split(":");

        if (state.productId) params.product_id = state.productId;
        if (state.rating) params.rating = state.rating;

        if (fresh) {
            page = 1;
            pending = [];
            hasMore = true;
        }

        // block clicks until this load finishes so two loads never overlap
        section.classList.add("loading");

        while (pending.length < settings.limit && hasMore) {
            const data = await request("", {
                ...params,
                page
            }).catch(error => console.error("Loox reviews failed:", error));

            if (!data) {
                section.classList.remove("loading");
                return;
            }

            pending.push(...(state.photos ? data.reviews.filter(review => review.media.length) : data.reviews));
            hasMore = data.pagination.hasMore;
            page += 1;
        }

        section.classList.remove("loading");

        if (fresh) list.innerHTML = "";

        list.append(...pending.splice(0, settings.limit).map(reviewCard));
        empty.hidden = list.children.length > 0;
        moreButton.hidden = !pending.length && !hasMore;
    }

    function renderState() {
        for (const tile of tiles) {
            tile.classList.toggle("active", tile.dataset.productId === state.productId);
        }

        for (const row of rows) {
            row.classList.toggle("active", Number(row.dataset.rating) === state.rating);
        }

        photosButton.classList.toggle("active", state.photos);
        clearButton.hidden = !(state.productId || state.rating || state.photos);

        const title = state.productTitle ? `${state.productTitle} ${settings.product_title_suffix}` : settings.list_title;
        listTitle.textContent = state.rating ? `${title} · ${state.rating} ${settings.star_label}` : title;
    }

    for (const tile of tiles) {
        tile.addEventListener("click", function () {
            const sameTile = tile.dataset.productId === state.productId;

            state.productId = sameTile ? "" : tile.dataset.productId;
            state.productTitle = sameTile ? "" : (tile.dataset.productTitle || "");
            renderState();
            loadReviews(true);
            loadCounts();
        });
    }

    for (const row of rows) {
        row.addEventListener("click", function () {
            const selected = Number(row.dataset.rating);

            // the counts show every rating, so picking one only reloads the list
            state.rating = selected === state.rating ? 0 : selected;
            renderState();
            loadReviews(true);
        });
    }

    sortSelect.addEventListener("change", function () {
        state.sort = sortSelect.value;
        sortValue.textContent = sortSelect.selectedOptions[0].text;
        loadReviews(true);
    });

    photosButton.addEventListener("click", function () {
        state.photos = !state.photos;
        renderState();
        loadReviews(true);
    });

    clearButton.addEventListener("click", function () {
        state.productId = "";
        state.productTitle = "";
        state.rating = 0;
        state.photos = false;
        renderState();
        loadReviews(true);
        loadCounts();
    });

    moreButton.addEventListener("click", function () {
        loadReviews(false);
    });

    renderState();
    loadReviews(true);
    loadCounts();
});
